export function getHashParameters() {
  if (!(window.location.hash || '')) {
    return null;
  }

  var arr = (window.location.hash || '').split('?')[1].split('&')
  var params = {}
  for (var i = 0; i < arr.length; i++) {
    var data = arr[i].split('=')
    if (data.length === 2) {
      params[data[0]] = data[1]
    }
  }
  return params
}
export function getHashParameter(key) {
  var params = getHashParameters();
  if (params) {
    console.log('params:', params);
    return params[key];
  } else {
    return '';
  }
}


export function getSearchParameters() {
  if (!(window.location.search || '')) {
    return null;
  }

  var arr = (window.location.search || '').split('?')[1].split('&')
  var params = {}
  for (var i = 0; i < arr.length; i++) {
    var data = arr[i].split('=')
    if (data.length === 2) {
      params[data[0]] = data[1]
    }
  }
  return params
}

export function getSearchParameter(key) {
  var params = getSearchParameters();
  if (params) {
    console.log('params:', params);
    return params[key];
  } else {
    return '';
  }
}